import { render, staticRenderFns } from "./MpCreateJS.vue?vue&type=template&id=34d0df64&scoped=true&"
import script from "./MpCreateJS.vue?vue&type=script&lang=js&"
export * from "./MpCreateJS.vue?vue&type=script&lang=js&"
import style0 from "./MpCreateJS.vue?vue&type=style&index=0&id=34d0df64&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d0df64",
  null
  
)

export default component.exports